<template>
  <div class="rs-listing">
    <!-- <RSFilters
      :fetchedYears="fetchedYears"
      :fetchedSeries="fetchedSeries"
      :fetchedCategories="fetchedCategories"
      :selectedYears="selectedYears"
      :selectedSeries="selectedSeries"
      :selectedCategories="selectedCategories"
      @selected-filters-change="onSelectedFiltersChange"
      :searchKeywords="searchKeywords"
      @search-keywords-change="onSearchKeywordsChange"
      :fetchedLanguages="fetchedLanguages"
      :selectedLanguage="selectedLanguage"
      @selected-language-change="onSelectedLanguageChange"
      :fetchedResults="fetchedResults"
    /> -->
    <RSResults :fetchedResults="fetchedResults" />
  </div>
</template>

<script>
// import RSFilters from "./RSParshaListingFilters.vue";
import RSResults from "./RSParshaListingResults.vue";

export default {
  name: "RSParshaListing",

  components: {
    // RSFilters,
    RSResults,
  },

  props: {
    lang: String,
    parsha: String,
    series: String,
    year: String,
    isFamilyEdition: String,
  },

  data: function () {
    return {
      fetchedResults: {},
      fetchedParshot: [],
      fetchedYears: [],
      fetchedSeries: [],
      fetchedCategories: [],
      fetchedLanguages: [],
      // selectedYears: [],
      // selectedSeries: [],
      // selectedCategories: [],
      // selectedLanguage: "",
      // searchKeywords: "",
      fetchResultsAbortController: undefined,
      isLoading: false,
    };
  },

  mounted: function () {
    // let refToThis = this;
    // this.fetchFilters().then(() => {
    //   refToThis.onRouteUpdated();
    // });
    this.fetchResults();
  },

  methods: {
    // fetchFilters() {
    //   let endpoint = "/wp-json/rs/v1/commentary-filters/";
    //   if (this.fetchResultsAbortController)
    //     this.fetchResultsAbortController.abort();
    //   this.isLoading = true;
    //   return fetch(endpoint)
    //     .then((response) => response.json())
    //     .then((data) => {
    //       this.fetchedParshot = data.filters.rs_cc_parsha;
    //       this.fetchedYears = data.filters.rs_cc_year.sort().reverse();
    //       this.fetchedSeries = data.filters.rs_cc_series;
    //       this.fetchedCategories = data.filters.category;
    //       this.fetchedLanguages = data.filters.languages;
    //       this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    fetchResults() {
      let endpoint = "/wp-json/rs/v1/commentary/";
      let queryString = [];
      queryString.push("limit=-1");
      queryString.push("lang=" + this.lang);
      queryString.push("is_family_edition=" + this.isFamilyEdition);
      if (this.parsha && this.parsha.length)
        queryString.push("rs_cc_parsha=" + this.parsha);
      if (this.series && this.series.length)
        queryString.push("rs_cc_series=" + this.series);
      if (this.year && this.year.length)
        queryString.push("rs_cc_year=" + this.year);

      queryString.forEach((element, i) => {
        if (i === 0) endpoint += "?" + element;
        else endpoint += "&" + element;
      });

      if (this.fetchResultsAbortController)
        this.fetchResultsAbortController.abort();
      this.fetchResultsAbortController = new AbortController();
      let signal = this.fetchResultsAbortController.signal;
      this.isLoading = true;

      fetch(endpoint, { signal })
        .then((response) => response.json())
        .then((data) => {
          this.isLoading = false;
          this.fetchedResults = data;
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.log(error);
          }
        });
    },

    // onSelectedFiltersChange(filters) {
    //   // https://app.asana.com/0/1201959796113610/1201960012700461/f
    //   if (window.dataLayer) {
    //     window.dataLayer.push({
    //       event: "search_filter",
    //       searchinfo: {
    //         year: filters.selectedYears.filter(
    //           (x) => !this.selectedYears.includes(x)
    //         ),
    //         series: filters.selectedSeries.filter(
    //           (x) => !this.selectedSeries.includes(x)
    //         ),
    //         category: filters.selectedCategories.filter(
    //           (x) => !this.selectedCategories.includes(x)
    //         ),
    //       },
    //     });
    //   }

    //   this.selectedYears = filters.selectedYears.sort();
    //   this.selectedSeries = filters.selectedSeries.sort();
    //   this.selectedCategories = filters.selectedCategories.sort();
    //   this.updateRouteIfNeeded();
    // },

    // onSearchKeywordsChange(keywords) {
    //   // https://app.asana.com/0/1201959796113610/1201960012700461/f
    //   if (keywords != this.searchKeywords) {
    //     if (window.dataLayer) {
    //       window.dataLayer.push({
    //         event: "search_filter",
    //         searchinfo: {
    //           keyword: keywords,
    //         },
    //       });
    //     }
    //   }

    //   this.searchKeywords = keywords;
    //   this.updateRouteIfNeeded();
    // },
  },
};
</script>
